// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Mcp_CatalogResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /mcp/catalog — proxy of the gateway's GET /catalog,
 * restricted to modules enabled on this tenant's instance.
 */
import type { Mcp_CatalogModuleRow } from './Mcp_CatalogModuleRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Mcp_CatalogResponseDados {
brand: string
version: string
modules: Mcp_CatalogModuleRow[]
required_group?: string
scope_prefix?: string
}

export type Mcp_CatalogResponse = ApiResponse<Mcp_CatalogResponseDados>;

registerResponseContract('Mcp_CatalogResponse', {
  brand:          { type: 'string',  required: true },
  version:        { type: 'string',  required: true },
  modules: {
    type: 'array',
    required: true,
    items: {
      name:  { type: 'string',  required: true },
      tools: {
        type: 'array',
        required: false,
        items: {
          name:        { type: 'string',  required: true },
          scope:       { type: 'string',  required: true },
          description: { type: 'string',  required: false },
          sensitive:   { type: 'boolean', required: false },
        },
      },
    },
  },
  required_group: { type: 'string',  required: false },
  scope_prefix:   { type: 'string',  required: false },
})
